"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WishlistItem = void 0;
var BaseEntity_1 = require("../../../models/concrete/BaseEntity");
;
var WishlistItem = /** @class */ (function (_super) {
    __extends(WishlistItem, _super);
    function WishlistItem(data) {
        var _a, _b;
        var _this = _super.call(this, data) || this;
        _this.category = {
            id: (_a = data === null || data === void 0 ? void 0 : data.category) === null || _a === void 0 ? void 0 : _a.id,
            name: (_b = data === null || data === void 0 ? void 0 : data.category) === null || _b === void 0 ? void 0 : _b.name
        };
        _this.imageId = data.image_id;
        _this.imageIds = data.images_ids;
        _this.code = data.code;
        _this.name = data.name;
        _this.price = data.price;
        _this.priceOld = data.price_old;
        _this.quantity = data.quantity;
        _this.unit = data.unit;
        _this.countStep = data.count_step;
        _this.shortDescription = data.short_description;
        _this.rating = data.rating;
        _this.weight = data.weight;
        _this.height = data.height;
        _this.depth = data.depth;
        _this.width = data.width;
        _this.slug = data.slug;
        _this.url = data.url;
        _this.isHit = data.is_hit;
        _this.isSpecial = data.is_special;
        _this.isNew = data.is_new;
        _this.countInPack = data.count_in_pack;
        _this.allowOutOfStock = data.allow_out_of_stock;
        _this.hasModifications = data.has_modifications;
        _this.productSetImageDots = data.product_set_image_dots;
        _this.options = data.options;
        _this.isProductSet = data.is_product_set;
        _this.isNotAvailable = data.is_not_available;
        _this.hasOptions = data.has_options;
        _this.modificationsCount = data.modifications_count;
        _this.productSetParents = data.productSetParents;
        _this.files = data.files;
        _this.optionGroupsCount = data.option_groups_count;
        _this.sku = data.sku;
        _this.reviewsCount = data.reviews_count;
        _this.reviewsRating = data.reviews_rating;
        _this.productSetChildrenCount = data.product_set_children_count;
        _this.shortCharacteristics = data.short_characteristics;
        _this.additionalCategories = data.additionalCategories;
        _this.characteristicGroup = data.characteristicGroup;
        _this.characteristicGroupId = data.characteristic_group_id;
        _this.bonusValue = data.bonus_value;
        _this.totalBonusValue = data.bonus_value_total;
        _this.isBonusesOutcoming = data.is_bonuses_outcoming;
        _this.createdAt = data.created_at;
        _this.updatedAt = data.updated_at;
        _this.exchangeUpdatedAt = data.exchange_updated_at;
        return _this;
    }
    return WishlistItem;
}(BaseEntity_1.BaseEntity));
exports.WishlistItem = WishlistItem;
;
//# sourceMappingURL=WishlistItem.js.map